export const capitalized = (string: String): string => string.charAt(0).toLocaleUpperCase() + string.slice(1)

import { DateOptions } from '../models/date.models'


export const formatDate = (date: Date, format: DateOptions) => {
    const options: Intl.DateTimeFormatOptions = {
        weekday: format.weekday,
        day: format.day,
        month: format.month,
        year: format.year
    };
    return new Intl.DateTimeFormat(format.language, options).format(date).toUpperCase().replace(/,/g, '')
}
